import { Box, Grid, Theme, Typography } from '@mui/material';
import React from 'react';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { KeyValue } from '../ApplicationDetails/personalDetails';
import { Gridstyles, Item, ItemDetails } from '../ApplicationDetails';
import { SubHeading } from '../investors/components';
import { currencyConversion, getUniqueIdentityText } from '../../utils/utilityFunctions';
import { investorTypeMasters } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';

export default function ContributorDetails({
  applicants = [],
}: {
  applicants: Partial<Applicant>[];
}): JSX.Element {
  const { locale } = useSelector((store: RootStateType) => store.currencyInfo);
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)


  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}
      >
        <Box>
          <Grid container >
            <Grid item xs={12}>
              <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                Contributor Details
              </Typography>
            </Grid>
            {applicants.map((applicant) => {
              return (
                <React.Fragment key={applicant.id}>
                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    <KeyValue title={'Name Of Entity'} description={applicant.name} />
                    <KeyValue
                      title={'Date of Registration/Incorporation'}
                      description={formatShortDate(applicant.dateOfBirth)}
                      sx={{ overflowWrap: 'anywhere' }}
                    />
                    <KeyValue
                      title={'Place of Registration/Incorporation'}
                      description={applicant.cityOfIncorporation}
                      sx={{ overflowWrap: 'anywhere' }}
                    />
                    <KeyValue
                      title={'Country of Registration/Incorporation'}
                      description={applicant?.countryOfIncorporation ?? "-"}
                      sx={{ overflowWrap: 'anywhere' }}
                    />
                    <KeyValue
                      title={'CKYC No./CKYC Acknowledge No./KIN No'}
                      description={applicant.ckycNo}
                    />
                    {applicant.investorType && (
                      <KeyValue
                        title={'Investor Type'}
                        description={investorTypeMasters[applicant.investorType]}
                      />
                    )}
                    <KeyValue title={`${getUniqueIdentityText(company)?.pan}`} description={applicant.panNo} />
                    <KeyValue
                      title={'KRA mobile'}
                      description={applicant?.kraMobileNumber ?? "-"}
                    />
                    <KeyValue
                      title={'KRA Email'}
                      description={applicant?.kraEmailId ?? "-"}
                    />
                    {/* <KeyValue
                      title={'CIN'}
                      description={applicant?.cin ?? "-"}
                    />
                    <KeyValue
                      title={'TIN/GST'}
                      description={applicant?.gstRegNo ?? "-"}
                    /> */}

                    <KeyValue
                      title="Mobile Number"
                      description={
                        applicant?.countryCode
                          ? (applicant?.countryCode) + '-' + (applicant?.mobile ?? "-")
                          : applicant?.mobile ?? "-"
                      }
                    />
                    <KeyValue
                      title="Email ID"
                      description={applicant?.email ?? "-"}
                    />
                  </Grid>
                  <SubHeading
                    sx={{
                      color: 'common.white',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Grid
                    item
                    container
                    // pb={5}
                    rowSpacing={3}
                    columnSpacing={5.5}
                    direction="row"
                  // justifyContent="space-between"
                  // alignItems="flex-start"
                  >
                    <KeyValue
                      title={'Gross Annual Income'}
                      description={applicant.grossAnnualIncome}
                    />
                    <KeyValue
                      title={'Net Worth'}
                      description={applicant.netWorth}
                      amount={currencyConversion(locale, applicant.netWorth)}
                    />
                    <KeyValue
                      title={'PEP Status'}
                      description={applicant.politicallyExposedPersonStatus}
                    />
                    <KeyValue
                      title={'Networth as on date'}
                      description={applicant?.netWorthDate ? formatShortDate(applicant.netWorthDate) : "-"}
                    />
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
